import { supabase, handleError, formatDate } from './apiClient'

export async function sendInquiry(data) {
  try {
    const { error } = await supabase
      .from('inquiries')
      .insert([{
        name: data.name,
        email: data.email,
        phone: data.phone,
        inquiry_type: data.inquiryType || 'GENERAL',
        subject: data.subject || '',
        message: data.message,
        property_id: null,
        property_title: null,
        budget: data.budget || null,
        preferred_contact_time: data.preferredContactTime || 'ANY',
        status: 'OPEN'
      }])

    if (error) handleError(error, 'submit inquiry')
    return { ok: true }
  } catch (error) {
    handleError(error, 'sendInquiry')
  }
}

export async function sendPropertyInquiry(data) {
  try {
    const { error } = await supabase
      .from('inquiries')
      .insert([{
        name: data.name,
        email: data.email,
        phone: data.phone,
        inquiry_type: data.inquiryType || 'PURCHASE',
        subject: data.subject || '',
        message: data.message,
        property_id: data.propertyId || null,
        property_title: data.propertyTitle || null,
        property_unit_id: data.propertyUnitId || null,
        budget: data.budget || null,
        preferred_contact_time: data.preferredContactTime || 'ANY',
        status: 'OPEN'
      }])

    if (error) handleError(error, 'submit property inquiry')
    return { ok: true }
  } catch (error) {
    handleError(error, 'sendPropertyInquiry')
  }
}

export async function fetchRecentInquiries() {
  try {
    const { data, error } = await supabase
      .from('inquiries')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(10)
    
    if (error) handleError(error, 'fetch recent inquiries')
    return data.map(inquiry => ({
      ...inquiry,
      createdAt: formatDate(inquiry.created_at)
    }))
  } catch (error) {
    handleError(error, 'fetchRecentInquiries')
  }
}

export async function fetchInquiries() {
  try {
    const { data, error } = await supabase
      .from('inquiries')
      .select('*')
      .order('created_at', { ascending: false })
    
    if (error) handleError(error, 'fetch inquiries')
    return data.map(inquiry => ({
      ...inquiry,
      createdAt: formatDate(inquiry.created_at)
    }))
  } catch (error) {
    handleError(error, 'fetchInquiries')
  }
}

export async function updateInquiryStatus(id, status) {
  try {
    const { data, error } = await supabase
      .from('inquiries')
      .update({ status })
      .eq('id', id)
      .select()
    
    if (error) handleError(error, 'update inquiry status')
    return data
  } catch (error) {
    handleError(error, 'updateInquiryStatus')
  }
}

export async function updateInquiryNotes(id, notes) {
  try {
    const { data, error } = await supabase
      .from('inquiries')
      .update({ admin_notes: notes })
      .eq('id', id)
      .select()
    
    if (error) handleError(error, 'update inquiry notes')
    return data
  } catch (error) {
    handleError(error, 'updateInquiryNotes')
  }
}

export async function deleteInquiry(id) {
  try {
    const { error } = await supabase
      .from('inquiries')
      .delete()
      .eq('id', id)
    
    if (error) handleError(error, 'delete inquiry')
  } catch (error) {
    handleError(error, 'deleteInquiry')
  }
}
